import { schema } from "normalizr";

const timeRecord = new schema.Entity(`time_records`);
const arrayOfTimeRecords = [timeRecord];

export { timeRecord, arrayOfTimeRecords };
